import React, { Fragment } from 'react'
import { Timeline, Typography } from 'antd'
import { map } from 'lodash'

import { EVENT_SUBTYPES, EVENT_TYPES } from '../../common/constants'
import {
  renderSimpleUpdateEvent,
  renderTreeSaveEvent,
} from '../../common/helpers'
import { formatCreatedByText } from '../../common/utils'

const renderDishTypeEvent = event => {
  const { type, subtype, original, changes, createdAt, createdBy } = event

  if (type === EVENT_TYPES.SAVE) {
    return renderTreeSaveEvent(event)
  }

  if (subtype === EVENT_SUBTYPES.ADDITIONAL_INGREDIENTS_DETAILS_CREATE) {
    return (
      <Timeline.Item key={event.id}>
        <Typography.Text>
          Created additional ingredients for {changes.name}:
        </Typography.Text>
        <br />
        {map(changes.additionalIngredients, ({ id, type, name }) => (
          <Fragment key={id}>
            <Typography.Text>
              {type} {name}
            </Typography.Text>
            <br />
          </Fragment>
        ))}
        <Typography.Text>
          {formatCreatedByText(createdAt, createdBy.name)}
        </Typography.Text>
      </Timeline.Item>
    )
  }

  if (subtype === EVENT_SUBTYPES.ADDITIONAL_INGREDIENTS_DETAILS_DELETE) {
    return (
      <Timeline.Item key={event.id}>
        <Typography.Text>
          Deleted additional ingredients from {original.name}:
        </Typography.Text>
        <br />
        {map(original.additionalIngredients, ({ id, type, name }) => (
          <Fragment key={id}>
            <Typography.Text>
              {type} {name}
            </Typography.Text>
            <br />
          </Fragment>
        ))}
        <Typography.Text>
          {formatCreatedByText(createdAt, createdBy.name)}
        </Typography.Text>
      </Timeline.Item>
    )
  }

  if (subtype === EVENT_SUBTYPES.ALTERNATIVE_INGREDIENTS_DETAILS_UPDATE) {
    return (
      <Timeline.Item key={event.id}>
        <Typography.Text>
          Updated replacement ingredient pairs for {changes.name}:
        </Typography.Text>
        <br />
        {map(
          changes.alternativeIngredients,
          ({
            ingredientId,
            alternativeIngredientId,
            ingredientName,
            alternativeIngredientName,
            notes,
          }) => (
            <Fragment key={`${ingredientId}-${alternativeIngredientId}`}>
              <Typography.Text>
                {ingredientName} - {alternativeIngredientName}
                {notes && ` (${notes})`}
              </Typography.Text>
              <br />
            </Fragment>
          ),
        )}
        <Typography.Text>
          {formatCreatedByText(createdAt, createdBy.name)}
        </Typography.Text>
      </Timeline.Item>
    )
  }

  if (subtype === EVENT_SUBTYPES.ALTERNATIVE_INGREDIENTS_DETAILS_CREATE) {
    return (
      <Timeline.Item key={event.id}>
        <Typography.Text>
          Created replacement ingredient pairs for {changes.name}:
        </Typography.Text>
        <br />
        {map(
          changes.alternativeIngredients,
          ({
            ingredientId,
            alternativeIngredientId,
            ingredientName,
            alternativeIngredientName,
            notes,
          }) => (
            <Fragment key={`${ingredientId}-${alternativeIngredientId}`}>
              <Typography.Text>
                {ingredientName} - {alternativeIngredientName}
                {notes && ` (${notes})`}
              </Typography.Text>
              <br />
            </Fragment>
          ),
        )}
        <Typography.Text>
          {formatCreatedByText(createdAt, createdBy.name)}
        </Typography.Text>
      </Timeline.Item>
    )
  }

  if (subtype === EVENT_SUBTYPES.ALTERNATIVE_INGREDIENTS_DETAILS_DELETE) {
    return (
      <Timeline.Item key={event.id}>
        <Typography.Text>
          Deleted replacement ingredient pairs from {original.name}:
        </Typography.Text>
        <br />
        {map(
          original.alternativeIngredients,
          ({
            ingredientId,
            alternativeIngredientId,
            ingredientName,
            alternativeIngredientName,
            notes,
          }) => (
            <Fragment key={`${ingredientId}-${alternativeIngredientId}`}>
              <Typography.Text>
                {ingredientName} - {alternativeIngredientName}
                {notes && ` (${notes})`}
              </Typography.Text>
              <br />
            </Fragment>
          ),
        )}
        <Typography.Text>
          {formatCreatedByText(createdAt, createdBy.name)}
        </Typography.Text>
      </Timeline.Item>
    )
  }

  return renderSimpleUpdateEvent(event, 'name', ['courseTypeId'])
}

export default renderDishTypeEvent
